import { useTranslation } from 'react-i18next';
import { Icon, Button } from '@sendible/design-system/src';
import { Container, HeaderBar, BackButton, EmptyReportState, EmptyStateCard, EmptyStateTitle, EmptyStateSubtitle } from '../../index.styles';

type ErrorStateProps = {
  isError: boolean;
  onBack: () => void;
};

export const ErrorState = ({ isError, onBack }: ErrorStateProps) => {
  const { t } = useTranslation('reports');

  const handleReload = () => {
    window.location.reload();
  };

  const title = isError ? t('new_reports_failed_to_load') : t('new_reports_not_found');
  const subtitle = t('new_reports_please_reload');

  return (
    <Container>
      <HeaderBar>
        <BackButton
          type="button"
          onClick={onBack}
        >
          <Icon name="close" />
        </BackButton>
      </HeaderBar>
      <EmptyReportState>
        <EmptyStateCard>
          <EmptyStateTitle>{title as string}</EmptyStateTitle>
          <EmptyStateSubtitle>{subtitle as string}</EmptyStateSubtitle>
          <Button
            appearance="primary"
            variation="fill"
            size={12}
            label={t('reload') as string}
            onClick={handleReload}
          />
        </EmptyStateCard>
      </EmptyReportState>
    </Container>
  );
};
